import { Component, OnInit, Optional, Inject, HostListener, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';
import { DialogsPermissionsService } from './dialogs-permissions.service';

@Component({
  selector: 'app-dialogs-permissions',
  templateUrl: './dialogs-permissions.component.html',
  styleUrls: ['./dialogs-permissions.component.scss']
})
export class DialogsPermissionsComponent implements OnInit {

  loading: boolean = true;
  @ViewChild('search') searchElement!: ElementRef;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: boolean,
              @Optional() private dialogRef: MatDialogRef<DialogsPermissionsComponent>,
              private dialogsPermissionsService: DialogsPermissionsService) { }

  @HostListener('window:keydown.alt.g', ['$event'])
  @HostListener('window:keydown.alt.s', ['$event'])
  @HostListener('window:keydown.alt.a', ['$event'])
  onDialogClick(event: KeyboardEvent): void {
    switch(event.key){
      case 'g' : {
        if(!this.deshabilitar()){
          this.editPermisos();
        }
        break;
      }
      case 's': {
        this.dialogRef.close();
        break;
      }
      case 'a': {
        this.searchElement.nativeElement.focus();
        break;
      }
    }
  }

  ngOnInit() {
    this.dialogsPermissionsService.init(this.data).subscribe(result => {
      console.log(result);
      this.loading = false;
    });
  }

  /**
  * @description
  * Edita los permisos modificados por el usuario
  */
  editPermisos(): void {

    let datospermisos = this.dialogsPermissionsService.rols;
    this.loading = true;
    for (let i = 0; i < datospermisos.length; i++) {
      if (datospermisos[i].operacion2 === undefined) {
        datospermisos[i].operacion2 = false;
      }
    }

    this.dialogsPermissionsService.gestionPermisos(datospermisos).subscribe((res: any) => {
      console.log(res);
      this.dialogRef.close(true);
      this.loading = false;
    }, (error: any) => {
      this.loading = false;
      console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Deshabilita o habilita el botón editar permisos
  */
  deshabilitar(){
    let rols = this.dialogsPermissionsService.rols;
    let original = this.dialogsPermissionsService.originalRols;
    return this.dialogsPermissionsService.compare(rols, original);
  }
}
